export default __webpack_public_path__ + "static/media/facebookLogo.1123cb23.png";